import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Tag } from '@models/common/tag';
import { AgActionIconButtonComponent } from "@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component";
import { HasRoleDirective } from '../../../../../directives/has-role.directive';

type ActionEvent = (data: Tag | undefined) => void;
type CellRendererParams = ICellRendererParams<Tag> & { edit: ActionEvent, delete: ActionEvent };

@Component({
  selector: 'app-ag-manage-tags-actions',
  standalone: true,
  imports: [
    AgActionIconButtonComponent,
    HasRoleDirective
  ],
  templateUrl: './ag-manage-tags-actions.component.html',
})
export class AgManageTagsActionsComponent implements ICellRendererAngularComp {
protected params!: CellRendererParams;

  agInit(params: CellRendererParams): void {
    this.params = params;
  }

  refresh(params: CellRendererParams): boolean {
    this.params = params;
    return true;
  }

  editTag(): void {
    this.params.edit(this.params.data);
  }

  deleteTag(): void {
    this.params.delete(this.params.data);
  }
}
